import fr from '../lang/fr';
import en from '../lang/en';
export default { fr, en };
